var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 62,
      height: 62
    },
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2465,
    cy: 30.6067,
    r: 30.6067,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5899 41.4089H20.9834C18.0924 41.4089 15.7632 38.8521 15.7632 35.7073V25.5058C15.7632 22.3482 18.1041 19.8042 20.9834 19.8042H42.5899C45.4809 19.8042 47.8101 22.361 47.8101 25.5058V35.7073C47.8218 38.8649 45.4809 41.4089 42.5899 41.4089Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4553 30.4465L28.366 25.2051V35.6878L37.4553 30.4465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fc1b94f451f59c73db7b3ba15feb2b7f.svg";
export { ForwardRef as ReactComponent };